// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { SimulationRun, SimulationRunT, verifySimulationRun } from "./simulation-run";

export class SimulationRunList implements flatbuffers.IUnpackableObject<SimulationRunListT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationRunList {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationRunList(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationRunList,
  ): SimulationRunList {
    return (obj || new SimulationRunList()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSimulationRunList(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationRunList,
  ): SimulationRunList {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationRunList()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  runs(index: number, obj?: SimulationRun): SimulationRun | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new SimulationRun()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  runsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startSimulationRunList(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addRuns(builder: flatbuffers.Builder, runsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, runsOffset, 0);
  }

  static createRunsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startRunsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endSimulationRunList(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSimulationRunList(
    builder: flatbuffers.Builder,
    runsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SimulationRunList.startSimulationRunList(builder);
    SimulationRunList.addRuns(builder, runsOffset);
    return SimulationRunList.endSimulationRunList(builder);
  }

  unpack(): SimulationRunListT {
    return new SimulationRunListT(
      this.bb!.createObjList<SimulationRun, SimulationRunT>(
        this.runs.bind(this),
        this.runsLength(),
      ),
    );
  }

  unpackTo(_o: SimulationRunListT): void {
    _o.runs = this.bb!.createObjList<SimulationRun, SimulationRunT>(
      this.runs.bind(this),
      this.runsLength(),
    );
  }

  unpackFields(...fields: string[]): SimulationRunListT {
    const t = new SimulationRunListT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("runs")) {
      t.runs = this.bb!.createObjList<SimulationRun, SimulationRunT>(
        this.runs.bind(this),
        this.runsLength(),
      );
    }
    return t;
  }
}

export class SimulationRunListT implements flatbuffers.IGeneratedObject {
  constructor(public runs: SimulationRunT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const runs = SimulationRunList.createRunsVector(
      builder,
      builder.createObjectOffsetList(this.runs),
    );

    return SimulationRunList.createSimulationRunList(builder, runs);
  }

  clone(): SimulationRunListT {
    const obj = new SimulationRunListT();
    obj.runs = this.runs.map((e) => e.clone());
    return obj;
  }

  equals(other: SimulationRunListT): boolean {
    if (this.runs.length !== other.runs.length) return false;
    for (let i = 0; i < this.runs.length; i++) {
      const a = this.runs[i];
      const b = other.runs[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifySimulationRunList(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimulationRun);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
